/*eslint-disable*/
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Favorite from "@material-ui/icons/Favorite";

import KisetsuNavbar from "components/Header/KisetsuNavbar.js";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";

import SectionPills from "./Sections/SectionPills.js";
import SectionInterested from "./Sections/SectionInterested.js";
import SectionImage from "./Sections/SectionImage.js";
import SubscribeLine from "./Sections/SubscribeLine.js";

import blogPostsPageStyle from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const useStyles = makeStyles(blogPostsPageStyle);

export default function BlogPostsPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();

  return (
    <div>
      <KisetsuNavbar />
      <Parallax image={require("assets/img/ilkbahar-Photoroom.jpg")} filter="dark" small>
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
              <h2 className={classes.title}>
                İlham Verici Yazılar ve Planlama İpuçları
              </h2>
              <h4 style={{ color: "rgba(255,255,255,0.85)" }}>
                Zamanı verimli kullanmanın yolları, üretkenlik teknikleri ve ajanda
                tutma alışkanlıkları hakkında güncel yazılar burada.
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classes.main}>
        <div className={classes.container}>
          {/* Öne çıkan kategoriler veya yazılar */}
          <SectionPills />

          {/* İlginizi çekebilecek diğer blog içerikleri */}
          {/* <SectionInterested /> */}
        </div>

        {/* Vurgulu büyük bir blog görseli veya kampanya alanı */}
        {/* <SectionImage /> */}

        {/* E-bülten üyelik alanı */}
        {/* <SubscribeLine /> */}
      </div>

      <Footer
        content={
          <div>
            <div className={classes.left}>
              <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href="/blog-posts" className={classes.block}>Blog</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/about-us" className={classes.block}>Hakkımızda</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/products" className={classes.block}>Mağaza</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/contact-us" className={classes.block}>İletişim</a>
            </ListItem>
          </List>
            </div>
            <div className={classes.right}>
              &copy; {1900 + new Date().getYear()} , sevgiyle hazırlandı{" "}
              <Favorite className={classes.icon} />{" "}
              <a href="/" target="_blank" rel="noopener noreferrer">
                Kisetsu
              </a>{" "}
              ile planlı ve estetik bir yaşam için.
            </div>
          </div>
        }
      />
    </div>
  );
}
